export function createCopyName(name: string, otherNames: string[]): string {
  let copyName = name;
  let copyNumber = 1;
  while (otherNames.includes(copyName)) {
    copyNumber++;
    copyName = `${name} (${copyNumber})`;
  }
  return copyName;
}

export function arraysEqual(arr1: (string | number)[], arr2: (string | number)[]): boolean {
  return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
}
